import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 支付类型
 */
class OilFeePayType extends UltMeta {
    ONLINE = new Meta(1, "线上");
    OFFLINE = new Meta(2, "线下");
}
export const OIL_FEE_PAY_TYPE = new OilFeePayType();

/**
 * 状态
 */
class OilFeeState extends UltMeta {
    UN_CONFIRM = new Meta(1, "待确认");
    SUCCESS = new Meta(2, "已支付");
}
export const OIL_FEE_STATE = new OilFeeState();